/* @flow */

import { callLiferayEndpoint } from './index';
import storageService from 'services/storage';
import utils from './utils';

import type {
  FindUsageParams,
  CreateUsageParams,
  UpdateUsageParams,
  SimplifiedUsage,
  Usage,
} from 'types';

const find = async (params: ?FindUsageParams): Promise<SimplifiedUsage[]> => {
  const { typeId } = params || {};
  const endpoint = typeId
    ? '/protones-portlet.usageboxes/find-by-user-and-tipo-simplified'
    : '/protones-portlet.usageboxes/find-by-user-simplified';
  const response = await callLiferayEndpoint(endpoint, {
    tipoId: typeId,
  });
  return response.map(utils.toSimplifiedUsage);
};

const get = async (id: number): Promise<Usage> => {
  const endpoint = '/protones-portlet.usageboxes/get';
  const response = await callLiferayEndpoint(endpoint, { id });
  return utils.toUsage(response);
};

const create = async (params: CreateUsageParams): Promise<Usage> => {
  const endpoint = '/protones-portlet.usageboxes/add-user-preset';
  const response = await callLiferayEndpoint(endpoint, {
    usageBox: {
      nome: params.name,
      dataInizioUtilizzo: params.startDate,
      dataInizioUtilizzoLocked: params.startDateLocked,
      dataFineUtilizzo: params.endDate,
      dataFineUtilizzoLocked: params.endDateLocked,
      esclusiva: params.exclusive,
      esclusivaLocked: params.exclusiveLocked,
      dataFineEsclusiva: params.exclusiveEndDate,
      dataFineEsclusivaLocked: params.exclusiveEndDateLocked,
      note: params.notes,
      noteLocked: params.notesLocked,
      produzioneId: params.productionId || 0,
      produzioneIdLocked: params.productionLocked,
      puntata: params.episode,
      puntataLocked: params.episodeLocked,
      canaleId: params.channelId || 0,
      canaleIdLocked: params.channelLocked,
      emittenteId: params.broadcastingId || 0,
      emittenteIdLocked: params.broadcastingLocked,
      piattaformaId: params.platformId || 0,
      piattaformaIdLocked: params.platformLocked,
      tipologiaEmissioneId: params.broadcastTypeId || 0,
      tipologiaEmissioneIdLocked: params.broadcastTypeLocked,
      territorioId: params.territoryId || 0,
      territorioIdLocked: params.territoryLocked,
      tipologiaUtilizzoId: params.usageTypeId || 0,
      tipologiaUtilizzoIdLocked: params.usageTypeLocked,
    },
  });
  return utils.toUsage(response);
};

const update = async (params: UpdateUsageParams): Promise<Usage> => {
  const response = await callLiferayEndpoint('/protones-portlet.usageboxes/update', {
    usageBox: {
      dataFineUtilizzo: params.endDate,
      dataInizioUtilizzo: params.startDate,
      nome: params.name,
      note: params.notes,
      produzioneId: params.productionId || 0,
      puntata: params.episode,
      territorioId: params.territoryId || 0,
      tipologiaUtilizzoId: params.usageTypeId || 0,
      usageBoxId: params.id,
      tipoId: 220000, // TODO necessario sennò viene cambiato da USER a ???
    },
  });
  return utils.toUsage(response);
};

const _delete = async (id: number): Promise<any> => {
  const endpoint = '/protones-portlet.usageboxes/delete';
  await callLiferayEndpoint(endpoint, { usageBoxId: id });
  return id;
};

const getSessionUsageId = (): number | void => {
  const sessionUsageId = storageService.getFromStorage('sessionUsageId');
  return sessionUsageId === 'undefined' ? undefined : JSON.parse(sessionUsageId);
};

const setSessionUsageId = (id?: number): number | void => {
  if (id !== undefined) {
    storageService.setInStorage('sessionUsageId', JSON.stringify(id));
  } else {
    storageService.deleteFromStorage('sessionUsageId');
  }
  return id;
};

export default {
  session: {
    getId: getSessionUsageId,
    setId: setSessionUsageId,
  },
  find,
  get,
  create,
  update,
  delete: _delete,
};
